import { useEffect, useState } from "react";

const useWakeLock = () => {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        let wakeLock = null;
        let mounted = true;

        const requestWakeLock = async () => {
            if (!("wakeLock" in navigator)) {
                console.warn("Screen Wake Lock wird nicht unterstützt.");
                return;
            }

            if (document.visibilityState !== "visible") {
                return;
            }

            try {
                if (wakeLock && !wakeLock.released) {
                    return;
                }

                wakeLock = await navigator.wakeLock.request("screen");

                if (!mounted) {
                    await wakeLock.release();
                    return;
                }

                setIsActive(true);

                wakeLock.addEventListener("release", () => {
                    if (mounted) {
                        setIsActive(false);
                    }
                });
            } catch (error) {
                console.error("Wake Lock fehlgeschlagen:", error);
                setIsActive(false);
            }
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                requestWakeLock();
            }
        };

        requestWakeLock();

        document.addEventListener(
            "visibilitychange",
            handleVisibilityChange
        );

        return () => {
            mounted = false;

            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
            );

            if (wakeLock && !wakeLock.released) {
                wakeLock.release();
            }
        };
    }, []);

    return isActive;
};

export default useWakeLock;